<yc-modal *ngIf="selectedOrg"
  [modalHeader]="'GLOBAL:hdrOrganizationNotEligible' | ycI18n: 'Organization Not Eligible'"
  [primaryButtonText]="'common:btnBack' | ycI18n: 'Back'"
  (onCancel)="closeModal.emit()"
  (onPrimaryClick)="closeModal.emit()">

  <div class="mb-2">
    <yc-i18n
      key="GLOBAL:textOrgNotEligibleDesc"
      defaultValue="The organization you selected is not eligible for grant disbursement. Click 'Back' below to return to the organization search and select a new organization.">
    </yc-i18n>
  </div>

  <yc-nonprofit-block-display
    [name]="selectedOrg.document.displayName || selectedOrg.document.name"
    [npoId]="selectedOrg.document.id"
    [addressString]="selectedOrg.document.addressString"
    [ein]="selectedOrg.document.registrationId"
    [isPrivateOrg]="selectedOrg.document.isPrivateOrg"
    [img]="{
      iconURL: selectedOrg.document?.iconURL,
      classification: selectedOrg.document?.classification
    } | getOrgIcon"
    [showClear]="false">
  </yc-nonprofit-block-display>

</yc-modal>